import { ShiftManagementLegalEntityEmployeesByCurrentDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export const useLegalEntityEmployeesByCurrent = ({ skip }: { skip: boolean }) => {
  const { employee } = useCurrentSession()
  const legalEntityId = employee?.legalEntity?.id

  const { loading, data } = useQuery(ShiftManagementLegalEntityEmployeesByCurrentDocument, {
    variables: {
      legalEntityIds: legalEntityId ? [legalEntityId] : [],
    },
    fetchPolicy: 'cache-first',
    skip: skip || !legalEntityId,
  })

  const legalEntityEmployees = data?.employees.employeeNames.map(({ id }) => id) ?? []

  return {
    loading,
    legalEntityEmployees,
  }
}
